import React, { Component } from 'react'
import { Form } from 'redux-form'
import OperatorField from '../components/OperatorField'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'

export default class CallerStateIsForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo, formData, change } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          You may want to chain several of these nodes together to provide a different flows for
          different regions. Typically, state will be unknown for mobile numbers. Make sure you
          handle this case.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        <OperatorField
          change={change}
          formData={formData}
          operators={['is', 'anyOf']}
          type="text"
        />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/CallerStateIs/CallerStateIsForm.jsx